import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useCart } from "../lib/cart";
import { Check } from "lucide-react";

export default function ProductPage() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [size, setSize] = useState("");
  const [activeImg, setActiveImg] = useState(0);
  const { add } = useCart();
  const [added, setAdded] = useState(false);

  useEffect(() => {
    api.get(`/products/${id}`).then(r => {
      setProduct(r.data);
      setSize(r.data.sizes?.[0] || "");
      setActiveImg(0);
    }).catch(() => {});
  }, [id]);

  if (!product) {
    return <div className="text-center py-32 text-brand-muted">Loading…</div>;
  }

  const gallery = (product.images && product.images.length > 0) ? product.images : [product.image].filter(Boolean);
  const mainImage = gallery[activeImg] || product.image;

  const handleAdd = () => {
    add(product, size, 1);
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  };

  return (
    <div data-testid="product-page" className="max-w-[1400px] mx-auto px-6 md:px-12 py-12 md:py-20">
      <Link to="/shop" className="text-xs tracking-[0.2em] uppercase text-brand-muted hover:text-brand-accent">
        ← Back to shop
      </Link>
      <div className="grid md:grid-cols-2 gap-10 md:gap-20 mt-8">
        <div>
          <div className="aspect-[3/4] overflow-hidden bg-brand-bg2">
            <img src={mainImage} alt={product.name} className="w-full h-full object-cover" data-testid="product-image" />
          </div>
          {gallery.length > 1 && (
            <div className="grid grid-cols-5 gap-2 mt-3" data-testid="product-thumbs">
              {gallery.slice(0, 5).map((src, i) => (
                <button
                  key={i}
                  onClick={() => setActiveImg(i)}
                  data-testid={`thumb-${i}`}
                  className={`aspect-square overflow-hidden bg-brand-bg2 border-2 transition-colors ${
                    activeImg === i ? "border-brand-accent" : "border-transparent hover:border-brand-line"
                  }`}
                >
                  <img src={src} alt="" className="w-full h-full object-cover" />
                </button>
              ))}
            </div>
          )}
        </div>
        <div className="md:py-8">
          <div className="overline">cindymaks Collections</div>
          <h1 className="font-serif text-4xl md:text-5xl mt-3 tracking-tight" data-testid="product-name">{product.name}</h1>
          <div className="text-2xl font-serif mt-4" data-testid="product-price">£{product.price.toFixed(2)}</div>

          <p className="text-base text-brand-muted mt-8 leading-relaxed" data-testid="product-description">{product.description}</p>

          <div className="mt-10">
            <div className="overline mb-3">Size</div>
            <div className="flex flex-wrap gap-2">
              {product.sizes?.map((s) => (
                <button
                  key={s}
                  onClick={() => setSize(s)}
                  data-testid={`size-${s}`}
                  className={`px-4 py-3 text-xs tracking-[0.2em] uppercase border transition-colors ${
                    size === s ? "bg-brand-ink text-brand-bg border-brand-ink" : "border-brand-line text-brand-ink hover:border-brand-ink"
                  }`}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>

          <button
            onClick={handleAdd}
            data-testid="add-to-cart-btn"
            disabled={!product.in_stock}
            className="btn-primary mt-10 w-full md:w-auto inline-flex items-center justify-center gap-2"
          >
            {added ? <><Check size={16} /> Added</> : product.in_stock ? "Add to bag" : "Sold out"}
          </button>

          <div className="mt-10 pt-8 border-t border-brand-line text-sm text-brand-muted space-y-2">
            <div>· Hand-tailored in small batches</div>
            <div>· Premium Ankara cotton</div>
            <div>· Ships worldwide</div>
          </div>
        </div>
      </div>
    </div>
  );
}
